import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Keyboard } from '@ionic-native/keyboard';
import { IonContent, ModalController, Platform } from '@ionic/angular';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent, Subscription } from 'rxjs';
import { ErrorMessage } from 'src/app/core/constants/validation-msg-constants';
import { AppData, ToastService } from 'src/app/shared';
import { getFormValidation } from 'src/app/shared/utils/common-functions';
import { AddressModel } from '../model/address';
import { AddressService } from '../service/address.service';

@Component({
  selector: 'app-add-edit-address-modal',
  templateUrl: './add-edit-address-modal.component.html',
  styleUrls: ['./add-edit-address-modal.component.scss'],
})
export class AddEditAddressModalComponent implements OnInit, OnDestroy {
  addressForm: FormGroup;
  addressModel = new AddressModel
  isOthersTag = false;
  isFormInit = false;
  isSubmitted = true;
  fullAddress: string;
  locality: string;
  keyBoardSubscription: Subscription
  keyboardHeights
  @Input() public modalObj: any;
  @ViewChild(IonContent, { static: false }) content: IonContent;



  constructor(private fb: FormBuilder,
    private addressService: AddressService,
    private toastService: ToastService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private platform: Platform,
    // private keyboard:Keybo
  ) {
    // if(this.platform.is('android')){
    //   this.keyboard.onKeyboardShow().subscribe((e) => {
    //     const offset = $(document.activeElement).offset().top;
    //     let height = (offset - e.keyboardHeight)*-1;
    //     height = height > 0 ? 0 : height;      
    //     $('body').animate({ 'marginTop': height + 'px' }, 100);
    //   });
    //   this.keyboard.onKeyboardHide().subscribe(e => {
    //     $('body').animate({ 'marginTop': 0 + 'px' }, 100);
    //   });
    // }
    this.keyBoardSubscription = fromEvent(window, 'keyboardWillShow').subscribe((ev) => {
      this.keyboardHeights = ev['keyboardHeight']

    })
  }

  ngOnInit() {

    console.log(this.modalObj.addressModel)
    this.fullAddress = this.modalObj.addressModel.fullAddress
    this.addressModel = Object.assign(this.addressModel, this.modalObj.addressModel);

    this.locality = this.modalObj.addressModel.locality
    if (this.modalObj.type === 'EDIT_ADDRESS') {
      this.initForm();
      if (this.addressModel._addressTag.toLowerCase() !== 'home'
        && this.addressModel._addressTag.toLowerCase() !== 'office') {
        this.addressForm.controls['addressTag'].setValue('others', { emit: false });
        console.log(this.addressForm);
      }
    } else {
      this.initForm();
      console.log(this.addressModel)
      // setTimeout(() => {
      // this.addressModel = Object.assign(this.addressModel, this.modalObj.addressModel);

      // },2000)
    }
  }
  async keyboardOpen(event) {
    // setTimeout(() => {
    //   const currentlyClikcedFieldOffset = event.target.offsetTop
    //   const contentHeight = document.querySelector('.address-form').clientHeight
    //   const viewHeight = contentHeight - this.keyboardHeights
    //   if (this.isOthersTag) {
    //     this.keyboardHeights -= 100
    //   }
    //   if (currentlyClikcedFieldOffset > viewHeight - 10) {
    //     this.content.scrollToPoint(0, this.keyboardHeights, 2000);
    //   } else if(event.target.offsetTop !== 0){
    //     this.content.scrollToPoint(0, 30, 2000);
    //   }else{
    //     this.content.scrollToPoint(0, this.keyboardHeights, 2000);
    //   }
    // }, 300)

  }

  initForm() {
    console.log('form initiated');
    this.addressForm = this.fb.group({
      'fullAddress': [this.addressModel['fullAddress'], [Validators.required]],
      'houseNum': [this.addressModel['houseNum'], [Validators.required]],
      'landmark': [this.addressModel['landmark'], [Validators.required]],
      'addressTag': [this.addressModel['addressTag'].toLowerCase()],
      'name': [this.addressModel['name']]
    });
    this.addressForm.get('addressTag').valueChanges.subscribe(val => {
      if (val == 'others') {
        this.isOthersTag = true;
        this.addressForm.controls["name"].setValidators(Validators.required);
        this.addressForm.controls["name"].updateValueAndValidity();
      } else {
        this.isOthersTag = false;
        this.addressForm.controls["name"].clearValidators();
        this.addressForm.controls["name"].updateValueAndValidity();
      }
    });
    this.isFormInit = true;
    console.log(this.addressForm)
  }
  get f() { return this.addressForm.controls; }

  // for checking valid fields
  getValid(fieldName) {
    return getFormValidation(this.f, fieldName, this.isSubmitted);
  }

  onAddAndUpdateAddress() {
    console.log(this.addressForm);
    this.isSubmitted = true;
    const formObj = this.addressForm.value;
    formObj['city'] = this.addressModel._city;
    formObj['state'] = this.addressModel._state;
    formObj['country'] = this.addressModel._country;
    formObj['pincode'] = this.addressModel._pincode;
    formObj['googleLocation'] = this.addressModel._googleLocation;
    formObj['locality'] = this.addressModel._locality;
    formObj['longLat'] = {
      coordinates: [this.modalObj.lng, this.modalObj.lat]
    }
    if (formObj['addressTag'] === 'home' || formObj['addressTag'] === 'office') {
      formObj['name'] = formObj['addressTag'];
    }
    if (this.addressForm.valid) {
      console.log(formObj);
      if (formObj['addressTag'] !== '') {
        if (this.addressModel._addressId !== '') {
          formObj['addressId'] = this.addressModel._addressId;
          // const modalAdrTag = this.editAddress['addressTag'];
          // const name = this.editAddress['name'];
          // if (modalAdrTag.toLowerCase() === formObj['addressTag']) {
          //     // if user is updating address tag and name then deleting key from object
          //     if (name.toLowerCase() === formObj['name'].toLowerCase()) {
          //         delete formObj['addressTag'];
          //         delete formObj['name'];
          //     } else {
          //         delete formObj['addressTag'];
          //     }
          // }
          console.log(formObj);
          this.onUpdateAddress(formObj);
        } else {
          console.log(formObj);
          this.onAddAddress(formObj);
        }
      } else {
        this.toastService.presentToast(ErrorMessage.PLEASE_SELECT_ADDRESS_TAG_MSG, 'Error', 'error');
      }
    } else {
      return;
    }
  }
  onUpdateAddress(formObj) {
    this.addressService.updateAddress(formObj).then((res) => {
      const responseData = res['body']['data'];
      this.activeModal.close(responseData);
    }, (error => {
      console.log(error);
    }));
  }
  onAddAddress(formObj) {
    this.addressService.addAddress(formObj).then((res) => {
      const responseData = res['body']['data']['address'];
      if (this.modalObj['type'] === 'ADD_ON_ADDRESS') {
        AppData.currentAddressSub$.next(formObj);
        let addressObj = {};
        addressObj = formObj;
        addressObj['addressId'] = responseData['addressId'];
        this.saveInLocationStorage(addressObj);
      }
      this.activeModal.close(responseData);
    }, (error => {
      console.log(error);
    }));
  }
  saveInLocationStorage(addressObj) {
    const userInfo = AppData.userInfoData;
    const localAddress = userInfo['address'];
    localAddress.push(JSON.parse(JSON.stringify(addressObj)));
    userInfo['address'] = localAddress;
    AppData.userInfoSub$.next(JSON.parse(JSON.stringify(userInfo)));
  }

  ngOnDestroy() {
    this.keyBoardSubscription.unsubscribe()
  }
}
